import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appSliderSubheader]',
})
export class SliderSubheaderDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
